export function getNameByStatus(camelCase) {
    if (!camelCase || typeof camelCase !== 'string') {
        return '';
    }

    // Find the index of "ByStatus"
    const byStatusIndex = camelCase.indexOf('Count' || 'ByStatus');

    // If "ByStatus" is not found, return the entire string capitalized
    if (byStatusIndex === -1) {
        return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
    }

    // Extract the part before "ByStatus"
    const firstPart = camelCase.slice(0, byStatusIndex);

    // Capitalize the first letter and return
    return firstPart.charAt(0).toUpperCase() + firstPart.slice(1) + 's';
}